<div class="d-flex flex-column m-4">
	<div class="d-flex flex-column">
		<div class="mx-auto display-3">{{ quoteService.quote.value.Name }}</div>
	</div>

	<div class="card d-flex flex-column">
		<div class="d-flex">
			<div class="display-6 mx-auto mt-2 mb-1">FOCUS solution proposal for {{ quoteService.quote.value.Opportunity.Account.Name }}</div>
		</div>
		<p-divider></p-divider>
		<div class="ms-auto item-med">Quote {{ quoteService.quote.value.QuoteNumber }}</div>
		<div class="ms-auto item-med" (click)="opportunityOwnerInfoPanel.toggle($event)">
			Rep: {{ quoteService.quote.value.Opportunity.Owner?.FirstName }} {{ quoteService.quote.value.Opportunity.Owner?.LastName.charAt(0) }}
		</div>
		<div class="ms-auto item-med">Last updated {{ app.moment(quoteService.quote.value.LastModifiedDate).format("l") }}</div>
		<div class="ms-auto item-med">Expires {{ app.moment(quoteService.quote.value.ExpirationDate).format("ddd l") }}</div>
	</div>
</div>

<p-overlayPanel #opportunityOwnerInfoPanel>
	<div class="d-flex flex-column">
		<div class="item-med">{{ quoteService.quote.value.Opportunity.Owner?.FirstName }} {{ quoteService.quote.value.Opportunity.Owner?.LastName }}</div>
		<div class="item-med">Mobile: {{ quoteService.quote.value.Opportunity.Owner?.MobilePhone }}</div>
		<div class="item-med">
			Email: <a href="mailto:{{ quoteService.quote.value.Opportunity.Owner?.Email }}">{{ quoteService.quote.value.Opportunity.Owner?.Email }}</a>
		</div>
	</div>
</p-overlayPanel>
